'use client';

import { c as _c } from "react/compiler-runtime";
import type { HofDashboardData } from '@/features/hof-dashboard/api/hof-dashboard-data';
import { Panel } from '@/features/hof-dashboard/components/dashboard-ui';
import { DeadlineList } from '@/features/hof-dashboard/components/deadline-list';
import { DocumentLinks } from '@/features/hof-dashboard/components/document-links';
import { FormCard } from '@/features/hof-dashboard/components/form-card';
import type { HofDashboardArea } from '@/features/hof-dashboard/constants';
import { translate } from '@/features/hof-dashboard/texts';
import type { SubmissionProgress } from '@/features/hof-dashboard/utils/submission-progress';
import type { Locale } from '@/types/types';
import type React from 'react';

/**
 * One area: its deadlines and documents, and one card per form the Hof hands
 * in there, in the order the editors set.
 */
export const AreaView: React.FC<{
  area: HofDashboardArea;
  data: HofDashboardData;
  progress: Record<string, SubmissionProgress>;
  locale: Locale;
}> = t0 => {
  const $ = _c(37);
  const {
    area,
    data,
    progress,
    locale
  } = t0;
  let t1;
  if ($[0] !== area || $[1] !== data.deadlines || $[2] !== data.documents || $[3] !== data.forms || $[4] !== data.hof || $[5] !== data.isReviewer || $[6] !== locale || $[7] !== progress) {
    let t2;
    if ($[9] !== area) {
      t2 = form => form.area === area;
      $[9] = area;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    const forms = data.forms.filter(t2);
    let t3;
    if ($[11] !== area || $[12] !== data.deadlines) {
      let t4;
      if ($[14] !== area) {
        t4 = deadline => deadline.area === area;
        $[14] = area;
        $[15] = t4;
      } else {
        t4 = $[15];
      }
      t3 = data.deadlines.filter(t4);
      $[11] = area;
      $[12] = data.deadlines;
      $[13] = t3;
    } else {
      t3 = $[13];
    }
    const deadlines = t3;
    let t4;
    if ($[16] !== area || $[17] !== data.documents) {
      let t5;
      if ($[19] !== area) {
        t5 = document => document.area === area;
        $[19] = area;
        $[20] = t5;
      } else {
        t5 = $[20];
      }
      t4 = data.documents.filter(t5);
      $[16] = area;
      $[17] = data.documents;
      $[18] = t4;
    } else {
      t4 = $[18];
    }
    const documents = t4;
    let t5;
    if ($[21] !== locale) {
      t5 = translate("deadlines", locale);
      $[21] = locale;
      $[22] = t5;
    } else {
      t5 = $[22];
    }
    let t6;
    if ($[23] !== t5) {
      t6 = <p className="text-xs font-semibold tracking-wider text-gray-500 uppercase">{t5}</p>;
      $[23] = t5;
      $[24] = t6;
    } else {
      t6 = $[24];
    }
    let t7;
    if ($[25] !== deadlines || $[26] !== locale) {
      t7 = <DeadlineList deadlines={deadlines} locale={locale} />;
      $[25] = deadlines;
      $[26] = locale;
      $[27] = t7;
    } else {
      t7 = $[27];
    }
    let t8;
    if ($[28] !== t6 || $[29] !== t7) {
      t8 = <div className="space-y-3">{t6}{t7}</div>;
      $[28] = t6;
      $[29] = t7;
      $[30] = t8;
    } else {
      t8 = $[30];
    }
    let t9;
    if ($[31] !== documents || $[32] !== locale) {
      t9 = documents.length > 0 && <div className="space-y-1"><p className="text-xs font-semibold tracking-wider text-gray-500 uppercase">{translate("areaDocuments", locale)}</p><DocumentLinks documents={documents} locale={locale} /></div>;
      $[31] = documents;
      $[32] = locale;
      $[33] = t9;
    } else {
      t9 = $[33];
    }
    let t10;
    if ($[34] !== t8 || $[35] !== t9) {
      t10 = <Panel className="grid gap-6 @3xl:grid-cols-2">{t8}{t9}</Panel>;
      $[34] = t8;
      $[35] = t9;
      $[36] = t10;
    } else {
      t10 = $[36];
    }
    t1 = <div className="space-y-6">{t10}{forms.length === 0 ? <Panel><p className="text-sm text-gray-500">{translate("noForms", locale)}</p></Panel> : <div className="grid items-start gap-6 @6xl:grid-cols-2">{forms.map(form_0 => {
          const formProgress = progress[form_0.id];
          return formProgress === undefined ? undefined : <FormCard key={form_0.id} form={form_0} progress={formProgress} hofId={data.hof.id} isReviewer={data.isReviewer} locale={locale} />;
        })}</div>}</div>;
    $[0] = area;
    $[1] = data.deadlines;
    $[2] = data.documents;
    $[3] = data.forms;
    $[4] = data.hof;
    $[5] = data.isReviewer;
    $[6] = locale;
    $[7] = progress;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
};